export default {
    prompts: []
}